import styles from './SiteMap.module.scss'

import MakerEnhance from 'maker-enhance'
import Image from 'next/image'

import Gutters from 'Clutch/Atoms/Gutters'
import Panel from 'Clutch/Atoms/Panel'
import Typography from 'Clutch/Atoms/Typography'

const SiteMapTitle = ({
  title,
  heroImageUrl = 'https://content.speedwaymotors.com/HomePageImages/Sitemap-bkg-default_(1).jpg',
  enableMaker,
  children,
}) => {
  const makerComponent = enableMaker ? <MakerEnhance user={'speedway'} /> : false

  if (heroImageUrl && !enableMaker) {
    return (
      <>
        <Panel layer={0} inverseTheme className={styles.heroSection}>
          <Image fill priority alt={''} className={styles.heroImage} src={heroImageUrl} />
          <div className={styles.gradient}></div>
          <Gutters>
            <Typography as={'h1'} font={'bold'} tone={'contrast'} size={2} className={styles.title}>
              {title}
            </Typography>
          </Gutters>
        </Panel>
        <Panel layer={0}>
          <Gutters>{children}</Gutters>
        </Panel>
      </>
    )
  }
  return (
    <>
      {makerComponent}

      <Typography as={'h1'} font={'bold'} size={2} className={styles.title}>
        {title}
      </Typography>
    </>
  )
}

export default SiteMapTitle
